var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/utilProgress.ts
var UtilProgress = class {
  /**
   * preFetchProgress
   * @param key
   */
  static preFetchProgress(key) {
    window.dispatchEvent(new CustomEvent(key + ":progress:start"));
  }
  /**
   * fetchProgress
   * @param key
   * @param response
   */
  static fetchProgress(key, response) {
    if (!response.ok) {
      throw Error(`HTTP error: ${response.status}`);
    }
    if (!response.body) {
      throw Error("ReadableStream API is not supported in this browser");
    }
    const contentEncoding = response.headers.get("content-encoding"), contentLength = response.headers.get(contentEncoding ? "x-file-size" : "content-length");
    if (!contentLength && !contentEncoding) {
      throw Error("Content-Length and Content-Encoding response header unavailable, we need one of this to calculate the progress on fetch response!");
    }
    let total = parseInt(contentLength, 10), loaded = 0, minimumLoadingTimePassed = false, minimumLoadingTimeMilliseconds = 500, minimumLoadingTimeHandler, checkMinimumLoadingTimeHandler;
    minimumLoadingTimeHandler = setTimeout(() => {
      clearInterval(minimumLoadingTimeHandler);
      minimumLoadingTimePassed = true;
    }, minimumLoadingTimeMilliseconds);
    let progressEvent = new CustomEvent(key + ":progress", {
      detail: {
        value: 0
      }
    });
    let _controller = {
      start(controller) {
        return __async(this, null, function* () {
          const reader = response.body.getReader();
          yield read();
          function read() {
            return __async(this, null, function* () {
              const { done, value } = yield reader.read();
              if (done) {
                try {
                  controller.close();
                } catch (e) {
                  console.log("error controller close: ", e);
                  throw e;
                }
                checkMinimumLoadingTimeHandler = setInterval(() => {
                  if (minimumLoadingTimePassed) {
                    clearInterval(checkMinimumLoadingTimeHandler);
                    window.dispatchEvent(new CustomEvent(key + ":progress:end"));
                  }
                }, 100);
                return;
              }
              loaded += value.byteLength;
              let progressValue = Math.round(loaded / total * 100);
              if (progressValue > 100) {
                progressValue = 99;
              }
              window.dispatchEvent(new CustomEvent(key + ":progress", {
                detail: {
                  value: progressValue
                }
              }));
              controller.enqueue(value);
              read();
            });
          }
        });
      }
    };
    if (window.ReadableByteStreamController !== void 0) {
      _controller["type"] = "bytes";
    }
    let stream = new ReadableStream(_controller), _response = new Response(stream);
    window.dispatchEvent(progressEvent);
    return _response;
  }
};
UtilProgress.POOL = [];

// src/index.ts
var src_default = UtilProgress;
export {
  src_default as default
};
